import { ErrorHandler } from '@src/shared/ui/components/ErrorHandler';
import { Card } from '@uhg-abyss/web/ui/Card';
import { IconSymbol } from '@uhg-abyss/web/ui/IconSymbol';
import { Layout } from '@uhg-abyss/web/ui/Layout';
import React from 'react';

/**
 * NotFound
 *
 * This component is used to display a not found message.
 *
 * @param button
 * @param icon
 * @param message
 * @param title
 * @returns {Element}
 * @constructor
 */
export function NotFound({ button = null, icon = '', message = '', title = '' }) {
  return (
    <ErrorHandler location="src/entities/Criteria/ui/components/Filters/components/NotFound/NotFound.jsx">
      <Layout.Group
        alignLayout="center"
        css={{
          padding: `var(--abyss-space-xs) 0px`,
        }}
      >
        <Card
          css={{
            background: 'transparent',
            borderStyle: 'dashed',
            boxShadow: 'none',
          }}
        >
          <Layout.Stack
            css={{
              padding: `var(--abyss-space-md) var(--abyss-space-xl)`,
            }}
            space={0}
          >
            <IconSymbol color="var(--abyss-colors-gray5)" icon={icon} size="48px" variant="outlined" />
            <div>
              <strong>{title}</strong>
            </div>
            <div style={{ fontWeight: 'normal' }}>{message}</div>
            <div style={{ marginTop: 'var(--abyss-space-lg)' }}>{button}</div>
          </Layout.Stack>
        </Card>
      </Layout.Group>
    </ErrorHandler>
  );
}
